import init from './thing'

const event =
{
    ...init,
    eventStatus : { title : 'État' }
};

export default event ;
